import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { FacilitiesListWrapper } from './facilities-list/FacilitiesList';
import { useIntl } from 'react-intl';

const FacilityPage = () => {
  const intl = useIntl(); 

  const facilitiesBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'FACILITY_PAGE.BREADCRUMB' }), 
      path: '/apps/facilities-management/facilities',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='facilities'
          element={
            <>
              <PageTitle breadcrumbs={facilitiesBreadcrumbs}>
                {intl.formatMessage({ id: 'FACILITY_PAGE.TITLE' })}
              </PageTitle>
              <FacilitiesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/facilities-management/facilities' />} />
    </Routes>
  );
};

export default FacilityPage;